define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Register another user",

    'incrowd_stats.num_responders': "{{num}} Expert Healthcare Professionals", // STATS - these don't support singular versions since we're way past that point
    'incrowd_stats.num_answers': "{{num}} Questions Answered",
    'incrowd_stats.time_to_complete': "{{num}} Minutes To Complete Average Survey",

    // INCROWD
    'incrowd.about': "Om",
    'incrowd.contact': "Kontakt",
    'incrowd.press': "Presse",
    'incrowd.careers': "Karriere",
    'incrowd.terms': "Betingelser",
    'incrowd.t_and_c': "Betingelser og vilkår",
    'incrowd.faq': "FAQ",
    'incrowd.privacy': "Privatlivsbeskyttelse",
    'incrowd.copyright': "{{year}} InCrowd Inc forbeholder sig alle rettigheder",
    'incrowd.blog': "Blog",
    'incrowd.support': "Kundeservice",
    'incrowd.info.ios': "Did you know that physicians in the InCrowd network can now send questions directly to their colleagues? Try it now using the <InCrowd iOS App>!",
    'incrowd.refer': "Like taking our surveys? <Refer a friend> today to join our crowd and you both earn 10 USD (or equivalent). Once your colleague answers answers a survey, they will receive a bonus!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "MicroSurveys,",
    'getstarted.encourage.title.two': "Massive Influence",
    'getstarted.encourage.subtitle': "Join thousands of qualified medical professionals influencing the development of new products and patient treatments through simple MicroSurveys, and we pay you too!",
    'getstarted.encourage.redirect_to_solutions': "Not a healthcare professional but want to learn more about InCrowd?",
    'getstarted.actions.title': "Are you a qualified medical professional?",
    'getstarted.actions.subtitle': "Sign up today and start earning money for answering healthcare focused MicroSurveys",
    'getstarted.button.continue': "Get Started",
    'getstarted.referral': "Tilmeld dig for at optjene penge fra undersøgelser plus henvisningsbonus fra %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Vi har brug for et par enkelte oplysninger om dig for at kunne lave din konto.",
    'details.profile_details': "Oplysninger om profil",
    'details.address_information': "Oplysninger om adresse",
    'details.professional_info': "Professional Information",
    'details.heading.finally': "…og som afslutning",
    'details.how_receive_surveys': "Hvordan vil du gerne modtage undersøgelserne?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "The basics",
    'professionchoice.encourage.subtitle': "Don't see your profession? Let us know <here> to ensure you are notified when we add your profession.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Who are you?",
    'authentication.encourage.subtitle': "InCrowd needs to verify your identity, but we will never reveal or distribute your personal information to third parties.",
    'authentication.actions.select_notifications': "Select how you would like to receive surveys from us",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Please wait while we validate your information",
    'validation.please_answer': "Please answer the following questions to help us validate your personal details",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Confirmation",
    'confirmation.validation_success.subtitle': "Din registrering er komplet, velkommen til InCrowd! Du modtager snart en bekræftelse pr. e-mail og/eller tekstbesked. Tak, fordi du deltager!",
    'confirmation.validation_error.title': "Additional Information Needed",
    'confirmation.validation_error.subtitle': "Sorry, %{userFirstName}, there was a problem validating your personal details.",
    'confirmation.actions_title': "What's next?",
    'confirmation.go_to_your_profile': "Gå til din profil",
    'confirmation.validation_success.actions_subtitle': "Du begynder at modtage vores 5-10 minutters micro-undersøgelser via e-mail eller tekstbesked i løbet af nogle dage. Har du endnu ikke tilmeldt dig til at modtage undersøgelser pr. tekstbesked? Du kan når som helstændre dine kommunikationsindstillinger via din InCrowd profil.",
    'confirmation.validation_error.actions_subtitle': "Please use the popup chat in the bottom right of the screen to speak with an InCrowd team member and address any outstanding issues.",
    'confirmation.referral.info.1': "I løbet af %{payoutBusinessDays} arbejdsdage fra din fuldførelse af den anden undersøgelse, og den person, som henviste dig, <vil hver modtage %{currency}%{referralBonusAmount}>. De %{currency}%{referralBonusAmount} føjes til din belønningskonto. Du kan når som helst logge på din <profil> for at opdatere dine præferencer, gennemse dine belønninger eller få adgang til åbne undersøgelser, som du er inviteret til.",
    'confirmation.referral.info.2': "Spørgsmål? <Chat med os>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Do you qualify?",
    'regftr.markets.accepting': "InCrowd Answers is currently accepting health care professionals who are actively employed in the following fields:",
    'regftr.peers.title': "Peers",
    'regftr.peers.subtitle': "Compare your responses to answers from your peers and learn from their replies.",
    'regftr.invites.title': "Invitations",
    'regftr.invites.subtitle': "Get new survey invitations through email or on your phone to maximize your earnings.",
    'regftr.earnings.title': "Earnings",
    'regftr.earnings.subtitle': "Manage and track your earnings and payment information.",
    'regftr.stats.title': "Stats",
    'regftr.stats.subtitle': "Access a dashboard with all your survey information and user details.",

    'contextual_help.sms': "Du vil modtage SMS-beskeder om åbne mikro-spørgeundersøgelser. Via SMS vil du få adgang til spørgeundersøgelser hurtigere og optjene flere belønninger. Dine oplysninger forbliver private og benyttes kun til invitationer for spørgeundersøgelser.",
    'contextual_help.specialty': "Inkluder venligst kun specialer som er tilknyttet din NPI, du har gennemført stipendier i eller medicinske områder, der hører ind under din primære specialitet. Hvis du i fremtiden har brug for at foretage ændringer i dine specialer, så kontakt support@incrowdnow.com.",
    // USER
    'user(s)': "Bruger |||| Brugere",
    'user.login': "Log ind",
    'user.logout': "Log ud",
    'user.register': "Tilmeld dig",
    'user.invitations': "Invitationer",
    'user.email': "Email",
    'user.pass_word': "Adgangskode",
    'user.mobile': "Mobil",
    'user.mobile.hint': "Oplys venligst landekode (+%{phoneCode} for %{countryName})",
    'user.title': "Titel",
    'user.title_with_example': "Titel (f.eks Dr./Fru/Hr.)",
    'user.first_name': "Fornavn",
    'user.last_name': "Efternavn",
    'user.middle_name': "Mellemnavn",
    'user.full_name': "En bruger",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "A User",
    'user.anonymous_admin': "Admin-bruger",
    'user.dashboard': "Kontrolpanel",
    'user.profile': "Profil",
    'user.profile.picture.upload': "Upload profilbillede",
    'user.profile.picture.change': "Ret",
    'user.primary_lang': "Primært sprog",
    'user.primary_lang?': "Hvad er dit primære sprog?",
    'user.survey_langs?': "Hvilke sprog kan du tale flydende?",
    'user.notify_email': "Giv besked på e-mail",
    'user.notify_mobile': "Giv besked på mobiltelefon",
    'user.contact_support': "Kontakt support",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Venligst <contact us>.",
    'user.profession': "Profession",
    'user.profession?': "Hvad er din profession?",
    'user.join_now': "Tilmeld dig nu!",
    'user.welcome_back': "Velkommen tilbage!",
    'user.not_a_member?': "Er du ikke medlem endnu?",
    'user.accept_terms': "Acceptér betingelserne",
    'user.accept_terms.yes': "Jeg accepterer",
    'user.remember_me': "Husk mig på denne enhed",
    'user.time_zone': "Tidszone",
    'user.payment.policy': "Hver gang du kommer op på 25%{currency} i belønninger, får du besked og vil være i stand til at vælge blandt vores betalingsmuligheder via din InCrowd profil. Spørgsmål? Kontakt os via nedenstående chat-vindue.",
    'user.country.live_work?': "Hvilket land bor og arbejder du i?",
    // FORMS
    'form.button.back': "Tilbage",
    'form.button.next': "Næste",
    'form.button.cancel': "Annuller",
    'form.button.submit': "Tilføj",
    'form.button.continue': "Fortsæt",
    'form.button.close': "Luk",
    'form.button.go!': "Forsæt!",
    'form.button.complete!': "Afslut nu!",
    'form.button.update': "Opdater",
    'form.button.finish': "Afslut",
    'form.button.search': "Søg",
    'form.button.end': "Slut",
    'form.search.no_matches': "Intet fundet",
    'form.confirm_email': "Bekræft e-mail",
    'form.confirm_pass_word': "Bekræft adgangskode",
    'form.required_fields': "Påkrævede felter",
    'form.nothing_selected': "Intet er valgt",
    'form.confirm_field': "Bekræft %{formFieldLabel}",
    'form.choice.n/a': "Udfyldes ikke",
    'form.choice.yes': "Ja",
    'form.choice.no': "Nej",
    'form.choice.blank_for_all': "Lad stå tomt for at vælge alle",
    'form.choices.select_all': "Vælg alle",
    'form.choices.deselect_all': "Fravælg alle",
    'form.field.private': "Privat felt",

    // USER ERRORS
    'user.error.dup_email': "En anden bruger er allerede registreret med den angivne email-adresse. <Log på i stedet?>",
    'user.error.dup_sms': "En anden bruger er allerede registreret med det angivne mobilnummer",
  }
})
